/**
 * Parses the param values from the URL
 * @param url Url to parse the param values from
 * @param paramName Param name to get the value from
 * @returns The value of the param from the URL
 */
export const parseParamValuesFromURL = (url: string, paramName: string) => {
	return new URLSearchParams(url.split("?")[1]).get(paramName);
};
